import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";

const SFPaper = (props) => {
  return (
    <Paper elevation={props.elevation} variant={props.variant} {...props}>
      {props.children}
    </Paper>
  );
};

SFPaper.defaultProps = {
  elevation: 0,
  variant: "elevation",
};

SFPaper.propTypes = {
  elevation: PropTypes.number,
  variant: PropTypes.oneOf(["elevation", "outlined"]),
};

export default SFPaper;
